import { MdEuro, MdOutlineShoppingBasket, MdTrendingUp, MdStarRate } from 'react-icons/md';
import { TbPigMoney } from 'react-icons/tb';
import { useParams } from 'react-router-dom';

import MiniStatistics from 'components/card/MiniStatistics';
import { getCustomerAnalytics, getCustomerScore } from 'interfaces/customer';
import { useEffect, useState } from 'react';

const CustomerStats = (props: { id?: string }) => {
    const [analytics, setAnalytics] = useState(null);
    const [score, setScore] = useState<number | null>(null);
    const params = useParams();
    const id = params.id || props.id;

    const getAnalytics = async () => {
        if (!id) return;
        const [res, scoreRes] = await Promise.all([getCustomerAnalytics(id), getCustomerScore(id)]);
        if (res) setAnalytics(res);
        setScore(scoreRes);
    };

    useEffect(() => {
        getAnalytics();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="col-span-12 grid h-full w-full grid-cols-2 gap-3 sm:gap-5 md:grid-cols-2 xl:grid-cols-4">
            <MiniStatistics
                name="Panier moyen"
                value={analytics && analytics.basketAverageValue != null ? `${analytics.basketAverageValue} €` : '- €'}
                icon={<MdOutlineShoppingBasket color="#0260CB" />}
                iconBg="bg-lightPrimary"
            />
            <MiniStatistics
                name="Reste à payer"
                value={
                    analytics && analytics.leftToPay != null ? `${analytics.leftToPay.toFixed(2)} €` : '- €'
                }
                icon={<TbPigMoney color="#0260CB" />}
                iconBg="bg-lightPrimary"
            />
            <MiniStatistics
                name="CA 3 dern. mois"
                value={
                    analytics && analytics.basketAverageValueLast90Days != null
                        ? `${analytics.basketAverageValueLast90Days} €`
                        : '- €'
                }
                icon={<MdEuro color="#0260CB" />}
                iconBg="bg-lightPrimary"
            />
            <MiniStatistics
                name="Marge 6 dern. mois"
                value={
                    analytics && analytics.marginLast180Days != null
                        ? `${analytics.marginLast180Days} €${
                              analytics.marginPercentageLast180Days != null
                                  ? ` (${analytics.marginPercentageLast180Days} %)`
                                  : ''
                          }`
                        : '- €'
                }
                icon={<MdTrendingUp color="#0260CB" />}
                iconBg="bg-lightPrimary"
            />
            <div
                title="Score 0-100 basé sur : activités récentes (appels/emails/RDV des 30 derniers jours), produits consultés, produits favoris, devis en cours, et récence de la dernière commande. Plus le score est élevé, plus le client est prioritaire à relancer."
                className="cursor-help"
            >
                <MiniStatistics
                    name="Score d'engagement"
                    value={score != null ? `${score} / 100` : '- / 100'}
                    icon={<MdStarRate color="#0260CB" />}
                    iconBg="bg-lightPrimary"
                />
            </div>
        </div>
    );
};

export default CustomerStats;
